import { useNavigate } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import AdBanner from "@/components/feature/AdBanner";
import { BRAND_LOGO_URL, BRAND_NAME } from "@/constants/brand";
import { useBrandSettings } from "@/hooks/useBrandSettings";

export default function SobrePage() {
  const navigate = useNavigate();
  const { logoSize } = useBrandSettings();
  const aboutLogoSize = Math.max(80, Math.round(logoSize * 1.2));

  return (
    <div className="min-h-screen bg-white relative">
      <Navbar />
      <div className="absolute top-0 left-0 right-0 h-48 md:h-64 bg-gradient-to-b from-alvinegro-black to-white z-0" />
      <main className="pt-20 md:pt-24 pb-12 relative z-10">
        <div className="w-full px-4 md:px-8">
          <Breadcrumb items={[{ label: "Início", path: "/" }, { label: "Sobre" }]} />
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8">
              <img
                src={BRAND_LOGO_URL}
                alt={BRAND_NAME}
                className="object-contain mx-auto mb-4"
                style={{ width: aboutLogoSize, height: aboutLogoSize }}
              />
              <h1 className="font-serif font-bold text-3xl md:text-4xl text-alvinegro-black mb-4">Sobre a Central Alvinegra</h1>
              <p className="text-alvinegro-muted text-lg">Tudo sobre o Glorioso, em um só lugar.</p>
            </div>
            <div className="prose max-w-none">
              <p className="text-base text-alvinegro-dark leading-relaxed mb-6">
                A Central Alvinegra nasceu da paixão inabalável de torcedores do Botafogo por um portal de notícias que fosse verdadeiramente alinhado com os interesses e sonhos da torcida alvinegra. Fundada em 2026, nossa missão é simples: ser a fonte mais confiável, rápida e apaixonada de informações sobre o Botafogo.
              </p>
              <h2 className="font-serif font-bold text-xl text-alvinegro-black mt-8 mb-4">Nossa Missão</h2>
              <p className="text-base text-alvinegro-dark leading-relaxed mb-6">
                Informar, engajar e emocionar a torcida do Botafogo com conteúdo de qualidade, credibilidade e velocidade. Queremos ser a voz da torcida, o olhar atento sobre o clube e o espaço onde todos os alvinegros se encontram para celebrar o Glorioso.
              </p>
              <h2 className="font-serif font-bold text-xl text-alvinegro-black mt-8 mb-4">Nossos Valores</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                {[
                  { title: "Credibilidade", desc: "Informações verificadas e fontes confiáveis em todas as publicações." },
                  { title: "Velocidade", desc: "Notícias em tempo real para você não perder nenhum lance." },
                  { title: "Paixão", desc: "Escrito por torcedores para torcedores. Sentimos cada vitória." },
                  { title: "Comunidade", desc: "Espaço para interação, debate e celebração coletiva." },
                ].map((v) => (
                  <div key={v.title} className="bg-alvinegro-light rounded-xl p-4">
                    <h3 className="font-semibold text-sm text-alvinegro-black mb-1">{v.title}</h3>
                    <p className="text-sm text-alvinegro-muted">{v.desc}</p>
                  </div>
                ))}
              </div>
              <h2 className="font-serif font-bold text-xl text-alvinegro-black mt-8 mb-4">Equipe</h2>
              <p className="text-base text-alvinegro-dark leading-relaxed mb-6">
                Nosso time é formado por jornalistas esportivos experientes, analistas de dados, designers e desenvolvedores que trabalham incansavelmente para entregar a melhor experiência para a torcida. Todos compartilham a mesma paixão: o Botafogo.
              </p>
            </div>
            <div className="mt-8 text-center">
              <button onClick={() => navigate("/contato")} className="bg-alvinegro-black text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-alvinegro-dark transition-colors cursor-pointer whitespace-nowrap">
                Entre em Contato
                <i className="ri-arrow-right-line ml-2" />
              </button>
            </div>
          </div>
          <div className="mt-8">
            <AdBanner variant="leaderboard" label="Publicidade" />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
